// extracted by mini-css-extract-plugin
export default {"card":"vp_QWX2l","animateIn":"vp_ckixi","wrapper":"vp_Ttcvj"};